import { Component } from 'react';
import FileDownload from 'react-file-download';
import './download-link-styles.css';
import irelandApi from '../../../irelandApi';
import redDownload from '../../../assets/img/reporting/Download-Red@2x.png';

class DownloadLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: false
    };
  }

  getDownloadable(downloadLink) {
    if (this.state.downloading) {
      return false;
    }

    this.setState({downloading: true});

    return irelandApi.get(`${downloadLink}`)
      .then((response) => {
        let filename = 'Report.csv';
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(response.headers['content-disposition']);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
        FileDownload(response.data, filename);

        this.setState({downloading: false});
      })
      .catch(() => {
      });
  }

  render() {
    return (
      <div className={`${this.props.className || ''} download-icon`} >
        <img
          src={this.props.icon || redDownload}
          className = {this.state.downloading ? 'downloading' : ''}
          onClick={() => this.getDownloadable(this.props.link)}
          alt='download'
        />
      </div>
    );
  }
}

export default DownloadLink;
